import './App.scss';
import AppRoutes from './app/routes/AppRoutes';

function App() {
    return (
        <div className='App'>
            <a
                className='site-redirect-banner'
                href='https://blacksoil.co.in'
                target='_self'
                rel='noreferrer'>
                <img
                    className='site-redirect-banner__img site-redirect-banner__img-desktop'
                    src='/img/saralscf-blacksoil-banner.png'
                    alt='SaralSCF strategic consolidation with BlackSoil. Visit BlackSoil.'
                />
                <img
                    className='site-redirect-banner__img site-redirect-banner__img-mobile'
                    src='/img/saralscf-blacksoil-banner-mobile.png'
                    alt='SaralSCF strategic consolidation with BlackSoil. Visit BlackSoil.'
                />
            </a>
            <AppRoutes />
        </div>
    );
}

export default App;
